import { SignUpRoot } from "@faire/retailer-visitor-shared/views/SignUp/SignUpRoot";
import { SignUpRoutes } from "@faire/retailer-visitor-shared/views/SignUp/SignUpRoutes";

export const SignUpRootWithRoutes: React.FC = () => {
  return (
    <SignUpRoot>
      <SignUpRoutes />
    </SignUpRoot>
  );
};
